import React from 'react';
import PropTypes from 'prop-types';
import TextField from '../../../../components/forms/TextField';

export const FirstNameInputComponent = React.forwardRef(({
  hasError,
  helperText,
  onBlur,
  onChange,
  themeType,
  value,
}, ref) => (
  <TextField
    hasError={hasError}
    helperText={helperText}
    id='in-page-lead-form-first-name-input'
    labelText='First name'
    maxLength={20}
    name='firstName'
    onBlur={onBlur}
    onChange={onChange}
    ref={ref}
    required
    themeType={themeType}
    value={value} />
));

FirstNameInputComponent.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
};

export default FirstNameInputComponent;
